import React from 'react';

import { Button } from '@mui/material';

import useToggleState from '~/hooks/useToggleState';

import MakeMeAnOfferModal from './MakeMeAnOfferModal';

export default function MakeMeAnOfferButton() {
  const {
    isToggled: isMakeAnOfferModalOpen,
    toggleOn: setOpenMakeAnOfferModal,
    toggleOff: setCloseMakeAnOfferModal,
  } = useToggleState(false);

  return (
    <>
      <Button variant="contained" onClick={setOpenMakeAnOfferModal}>
        Make Me An Offer
      </Button>
      {isMakeAnOfferModalOpen && (
        <MakeMeAnOfferModal open={isMakeAnOfferModalOpen} onClose={setCloseMakeAnOfferModal} />
      )}
    </>
  );
}
